module.exports = "/assets/data/44c53d5dcbb80c84f3739cc2158b9260-MK42.data.json";